import { toTitleCase } from "@/utils/textFormatting";

export const isValidMetadata = (value?: string | null): value is string =>
  !!value && value.trim() !== "" && value.toLowerCase() !== "unknown";

export const resolveDisplayTitle = (
  manuscriptTitle: string | null | undefined,
  fileName: string,
): string =>
  isValidMetadata(manuscriptTitle)
    ? toTitleCase(manuscriptTitle)
    : fileName || "—";

// undefined = not extracted yet (blank); null/empty/"Unknown" = extracted but unavailable.
export const resolveDisplayAuthor = (
  manuscriptAuthor: string | null | undefined,
): string => {
  if (manuscriptAuthor === undefined) return "";
  return isValidMetadata(manuscriptAuthor)
    ? toTitleCase(manuscriptAuthor)
    : "Unknown";
};
